import { render, staticRenderFns } from "./StatisticsAccessByFunction.vue?vue&type=template&id=09f7f8f6&"
import script from "./StatisticsAccessByFunction.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports